module.exports = __webpack_public_path__ + "media/2_2-1.eab865b3.mp3";